import React from "react";
import Palette from "./components/layout/Palette";
import Canvas from "./components/layout/Canvas";

function App() {
  return (
    <div className="container-fluid app-shell bg-transparent">
      <div className="row g-0 vh-100">
        <aside className="col-12 col-lg-3 col-xl-3 app-sidebar p-4 p-lg-4">
          <div className="sidebar-brand">
            <span className="sidebar-brand-icon" aria-hidden>
              {"\u{1F9E9}"}
            </span>
            <span>Page Builder</span>
          </div>
          <Palette />
        </aside>

        <main className="col-12 col-lg-9 col-xl-9 canvas-wrap">
          <div className="canvas-card h-100 overflow-auto">
            <Canvas />
          </div>
        </main>
      </div>
    </div>
  );
}

export default App;
